import React, { useState, useRef } from 'react';
import { stylistAPI } from '../../../../services/api';
import { X, Upload, Loader2 } from 'lucide-react';

const EditRecommendationModal = ({ recommendation, onClose, onUpdated }) => {
  const [formData, setFormData] = useState({
    product_url: recommendation.product_url || '',
    description: recommendation.description || '',
    image_url: recommendation.image_url || ''
  });
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const response = await stylistAPI.uploadImage(file);
      const fullUrl = response.url;
      setFormData({ ...formData, image_url: fullUrl });
    } catch (err) {
      console.error('Upload error:', err);
      alert('Ошибка загрузки изображения');
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.product_url || !formData.description) {
      alert('Заполните ссылку и описание');
      return;
    }

    setLoading(true);
    try {
      const response = await stylistAPI.updateRecommendation(recommendation.id, formData);
      onUpdated(response.recommendation);
    } catch (err) {
      console.error('Error updating recommendation:', err);
      alert('Ошибка при обновлении');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-l)', zIndex: 1000 }}>
      <div style={{ backgroundColor: 'var(--white)', maxWidth: '500px', width: '100%', maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ padding: 'var(--space-l)', borderBottom: '1px solid var(--soft-gray)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem', fontWeight: 400 }}>Редактировать рекомендацию</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}><X size={20} /></button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: 'var(--space-l)' }}>
          {/* Image Upload */}
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{ display: 'block', fontFamily: 'var(--font-body)', fontSize: '0.75rem', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--mid-gray)', marginBottom: 'var(--space-s)' }}>
              Изображение (опционально)
            </label>
            <input type="file" ref={fileInputRef} onChange={handleFileChange} accept="image/*" style={{ display: 'none' }} />
            {formData.image_url ? (
              <div style={{ position: 'relative' }}>
                <img src={formData.image_url} alt="" style={{ width: '100%', height: '150px', objectFit: 'cover' }} />
                <button type="button" onClick={() => setFormData({ ...formData, image_url: '' })} style={{ position: 'absolute', top: '8px', right: '8px', padding: '4px', backgroundColor: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                  <X size={16} />
                </button>
              </div>
            ) : (
              <button type="button" onClick={() => fileInputRef.current?.click()} disabled={uploading} style={{ width: '100%', padding: 'var(--space-l)', border: '2px dashed var(--soft-gray)', backgroundColor: 'var(--cream)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--space-s)' }}>
                {uploading ? <Loader2 size={20} style={{ animation: 'spin 1s linear infinite' }} /> : <Upload size={20} />}
                {uploading ? 'Загрузка...' : 'Загрузить фото'}
              </button>
            )}
          </div>

          {/* Product URL */}
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{ display: 'block', fontFamily: 'var(--font-body)', fontSize: '0.75rem', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--mid-gray)', marginBottom: 'var(--space-s)' }}>
              Ссылка на товар *
            </label>
            <input
              type="url"
              value={formData.product_url}
              onChange={(e) => setFormData({ ...formData, product_url: e.target.value })}
              placeholder="https://..."
              required
              style={{ width: '100%', padding: '12px 16px', border: '1px solid var(--soft-gray)', fontFamily: 'var(--font-body)', fontSize: '0.875rem' }}
            />
          </div>

          {/* Description */}
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{ display: 'block', fontFamily: 'var(--font-body)', fontSize: '0.75rem', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--mid-gray)', marginBottom: 'var(--space-s)' }}>
              Описание *
            </label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Опишите рекомендацию..."
              required
              rows={3}
              style={{ width: '100%', padding: '12px 16px', border: '1px solid var(--soft-gray)', fontFamily: 'var(--font-body)', fontSize: '0.875rem', resize: 'vertical' }}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{ width: '100%', padding: '16px', backgroundColor: 'var(--black)', color: 'var(--white)', border: 'none', fontFamily: 'var(--font-body)', fontSize: '0.8125rem', letterSpacing: '1px', textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Сохранение...' : 'Сохранить'}
          </button>
        </form>
        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
};

export default EditRecommendationModal;
